import LayoutComposer from './LayoutComposer.js';
import LayoutSingleColumn from './LayoutSingleColumn/LayoutSingleColumn';
import LayoutSideNavigation from './LayoutSideNavigation/LayoutSideNavigation';
import LayoutSalesSideNavigation from './LayoutSalesSideNavigation/LayoutSalesSideNavigation';

export { LayoutSingleColumn, LayoutSideNavigation, LayoutSalesSideNavigation };
export default LayoutComposer;
